import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <section
      className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 bg-[#F7F4EF] pt-32"
      data-nav-theme="light"
    >
      <span className="uppercase tracking-[0.3em] text-[11px] text-neutral-500 mb-4">
        Erreur 404
      </span>
      <h1
        className="font-display uppercase text-neutral-900 leading-[0.95] mb-6"
        style={{ fontSize: "clamp(32px, 5vw, 64px)" }}
      >
        Page introuvable
      </h1>
      <p className="text-neutral-600 text-[15px] leading-relaxed max-w-md mb-10">
        La page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <button
        onClick={() => navigate("/")}
        className="inline-flex items-center gap-3 bg-neutral-900 text-white rounded-full pl-6 pr-2 py-2 text-[12px] uppercase tracking-widest font-medium hover:bg-[#9F8B76] transition-colors"
      >
        Retour à l'accueil
        <span className="w-9 h-9 rounded-full bg-[#9F8B76] flex items-center justify-center">
          →
        </span>
      </button>
    </section>
  );
};

export default NotFound;
